<template>
  <div class="public-content platform-sku">
    <div class="breadcrumb">平台关联SKU组</div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="platformNum" label="SKU组code" min-width="10px">
          </el-table-column>
          <el-table-column prop="username" label="SKU组名称" min-width="10px">
          </el-table-column>
          <el-table-column prop="platformNum" label="产品名称" min-width="10">
          </el-table-column>
          <el-table-column prop="platformName" label="SKU组图片" min-width="10">
          </el-table-column>
          <el-table-column prop="payDate" label="属性组合" min-width="10">
          </el-table-column>
          <el-table-column prop="payDate" label="产品类别" min-width="10">
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination"></v-pagination>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
export default {
  name: 'platform-sku',
  components: {
    VPagination, CombinedDialog
  },
  data () {
    return {
      formInline: {
        order: '',
        user: '',
        platform: '',
        business: '',
        platformName: '',
        orderType: '',
        payStatus: '',
        orderStatus: '',
        createTime: ''
      },
      tableData: [{
        orderNumber: '29828239888',
        username: '',
        platformNum: 'v29828239888',
        platformName: '123',
        plateformType: '',
        salesman: 'zhangsan',
        orderType: '',
        createDate: '',
        payDate: '',
        plateformPrice: '',
        payWay: '',
        orderStatus: '审核'
      }, {
        orderNumber: '29828239888',
        username: '',
        platformNum: '',
        platformName: '123',
        plateformType: '',
        salesman: 'zhangsan',
        orderType: '',
        createDate: '',
        payDate: '',
        plateformPrice: '',
        payWay: '',
        orderStatus: '查看/编辑'
      }],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }]
    }
  },
  methods: {
  }
}
</script>
 <style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
